import React from 'react';

const ModalContext = React.createContext(null);

export default ModalContext;
